/* eslint-disable */
// @ts-nocheck

import { axiosFetch } from "@/utils/axiosFetch";

import * as common from "./common";
export { common };

import { method, headers } from "./_util";

export class UserService {
  constructor(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== "undefined" ? uriPrefix : "";
  }

  Self(req = {}, option) {
    const uri = `${this.uriPrefix}/v1/users/self`;
    return axiosFetch(uri, { method, headers }, option);
  }
}

export const userServiceClient = new UserService();
